import Joyride from "react-joyride";

import { useTutorialContext } from "./context/BerichtsheftContext";
import { useTutorialCallbackHandler } from "./context/useTutorial";

import i18next from "i18next";
import { z } from "zod";
import { zodI18nMap } from "zod-i18n-map";
// Import your language translation files
import { Outlet } from "react-router-dom";
import translation from "zod-i18n-map/locales/de/zod.json";
// lng and resources key depend on your locale.
i18next.init({
  lng: "de",
  resources: {
    de: { zod: translation },
  },
});
z.setErrorMap(zodI18nMap);

// export configured zod instance
export { z };

function App() {
  const tutorial = useTutorialContext();
  const { steps, run, stepIndex } = tutorial;
  const handleCallback = useTutorialCallbackHandler(tutorial);

  return (
    <>
      <Joyride
        callback={handleCallback}
        continuous
        run={run}
        stepIndex={stepIndex}
        steps={steps}
      />
      <Outlet />
    </>
  );
}

export default App;
